import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { MessageWrapper } from '../Styles';

export const SettingsButton = observer(() => {
  const {
    DebuggerStore: { setDebugProperty, showSettings },
  } = useStores();

  return (
    <MessageWrapper
      bgColor="#0095E8"
      color="#fff"
      onClick={() => setDebugProperty('showSettings', !showSettings)}
      style={{ cursor: 'pointer' }}
    >
      {showSettings ? (
        <>
          <i aria-hidden="true" className="fa fa-motorcycle" />
          View Data
        </>
      ) : (
        <>
          <i aria-hidden="true" className="fa fa-cog" />
          Settings
        </>
      )}
    </MessageWrapper>
  );
});

export default SettingsButton;
